<template lang="pug">
v-row(no-gutters)
  v-col(cols="4", sm="2")
    Avatar(
      :name="avatarData.name",
      :image-url="avatarData.imageUrl",
      :profile-url="avatarData.profileUrl",
      :clients="avatarData.clients",
      :variant="variant"
    )
  v-col(cols="8", sm="10")
    Subtitle(
      :text="name",
      custom-class="mt-2 mb-0",
      style="cursor: pointer",
      :font-weight="700",
      @click="goToProfile"
    )
    RelativeTime(:date-time="createdAt")
    RenderedWysiwygContent(
      :html="text",
      v-if="!isXsScreenSize",
      custom-class="mt-4"
      style="overflow-x:auto;"
      :attachments="attachments"
    )
  v-col(cols="12")
    RenderedWysiwygContent(
      :html="text",
      v-if="isXsScreenSize",
      custom-class="mt-4"
      style="overflow-x:auto;"
      :attachments="attachments"
    )
</template>

<script lang="ts">
import Vue from "vue"
import { PropType } from "vue"
import TextHTML from "../UI/TextHTML.vue"
import Subtitle from "../UI/Subtitle.vue"
import RelativeTime from "../UI/RelativeTime.vue"
import Avatar from "../UI/Avatar.vue"
import { IAvatar } from "interfaces/avatar.interface"
import { goToUrl } from "../../helpers/navigation"
import { Attachment } from "suus-api"
import RenderedWysiwygContent from "components/Wysiwyg/RenderedWysiwygContent.vue"
export default Vue.extend({
  name: "TopicBlock",
  components: {
    RenderedWysiwygContent,
    Subtitle,
    RelativeTime,
    TextHTML,
    Avatar,
  },
  props: {
    name: { type: String, required: true },
    createdAt: { type: String, required: true },
    text: { type: String, required: true },
    avatarData: { type: Object as PropType<IAvatar>, required: true },
    profileUrl: { type: String, required: false },
    attachments: {
      type: Array as () => Attachment[],
      required: false,
    },
  },
  computed: {
    isXsScreenSize(): boolean {
      return this.$vuetify.breakpoint.name === "xs"
    },
    variant(): "md" | "lg" {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "md"
        case "sm":
          return "md"
        case "md":
          return "md"
        default:
          return "lg"
      }
    },
  },
  methods: {
    goToProfile() {
      if (this.profileUrl) goToUrl(this.profileUrl)
    },
  },
})
</script>
